import {
  APPLICANT_STAGE,
  APPLICANT_TRANSITION_ACTION,
} from '../../../../RentalPortalApplicant'

export const QA_NAME_APPLICANT_DECISION_PANEL = 'applicantDecisionPanel'

export const QA_NAME_APPLICANT_DECISION_APPLICANT = 'applicantDecisionApplicant'

export const QA_NAME_APPLICANT_DECISION_APPLICANT_AVATAR =
  'applicantDecisionApplicantAvatar'

export const QA_NAME_APPLICANT_DECISION_SELECTED_BY =
  'applicantDecisionSelectedBy'

export const QA_NAME_APPLICANT_DECISION_APPROVAL_RULE =
  'applicantDecisionApprovalRule'

export const QA_NAME_APPLICANT_DECISION_REVIEWER = 'applicantDecisionReviewer'

export const QA_NAME_APPLICANT_DECISION_ESCALATION =
  'applicantDecisionEscalation'

export const QA_NAME_APPLICANT_DECISION_CONFLICT = 'applicantDecisionConflict'

export const QA_NAME_APPLICANT_DECISION_MODAL = 'applicantDecisionModal'

export const QA_NAME_APPLICANT_DECISION_NOTE_INPUT =
  'applicantDecisionNoteInput'

export const QA_NAME_APPLICANT_DECISION_NOTE = 'applicantDecisionNote'

export const APPLICANT_DECISION_ACTION = {
  approve: 'approve',
  rejectSelection: 'reject_selection',
  select: 'select',
}

export const APPLICANT_DECISION_TRANSITION_ACTION = {
  [APPLICANT_DECISION_ACTION.approve]: APPLICANT_TRANSITION_ACTION.approve,
  [APPLICANT_DECISION_ACTION.rejectSelection]:
    APPLICANT_TRANSITION_ACTION.rejectSelection,
  [APPLICANT_DECISION_ACTION.select]: APPLICANT_TRANSITION_ACTION.select,
}

export const APPLICANT_DECISION_TRANSITION_KEY = {
  [APPLICANT_DECISION_ACTION.approve]: APPLICANT_STAGE.approved,
  [APPLICANT_DECISION_ACTION.rejectSelection]:
    APPLICANT_DECISION_ACTION.rejectSelection,
  [APPLICANT_DECISION_ACTION.select]: APPLICANT_STAGE.selected,
}

// TODO: name the approved applicant once the backend serves it with the refused select
export const APPLICANT_DECISION_BLOCKED_TOOLTIP_KEY = {
  [APPLICANT_DECISION_ACTION.approve]:
    'RentalPortal.ApplicantDecisionSelectorBlockedTooltipKey',
  [APPLICANT_DECISION_ACTION.rejectSelection]:
    'RentalPortal.ApplicantDecisionSelectorBlockedTooltipKey',
  [APPLICANT_DECISION_ACTION.select]:
    'RentalPortal.ApplicantDecisionListingApprovedTooltipKey',
}

export const APPLICANT_DECISION_SAME_USER_AS_SELECTOR_REASON =
  'same_user_as_selector'

export const QA_NAME_APPLICANT_DECISION_ACTION = {
  [APPLICANT_DECISION_ACTION.approve]: 'applicantDecisionApprove',
  [APPLICANT_DECISION_ACTION.rejectSelection]: 'applicantDecisionRejectBtn',
  [APPLICANT_DECISION_ACTION.select]: 'applicantDecisionSelect',
}

export const APPLICANT_DECISION_ACTION_LABEL_KEY = {
  [APPLICANT_DECISION_ACTION.approve]:
    'RentalPortal.ApplicantDecisionApproveBtnKey',
  [APPLICANT_DECISION_ACTION.rejectSelection]:
    'RentalPortal.ApplicantDecisionRejectBtnKey',
  [APPLICANT_DECISION_ACTION.select]:
    'RentalPortal.ApplicantDecisionSelectBtnKey',
}

export const APPLICANT_DECISION_CONFIRM_TITLE_KEY = {
  [APPLICANT_DECISION_ACTION.approve]:
    'RentalPortal.ApplicantDecisionApproveConfirmTitleKey',
  [APPLICANT_DECISION_ACTION.rejectSelection]:
    'RentalPortal.ApplicantDecisionRejectConfirmTitleKey',
  [APPLICANT_DECISION_ACTION.select]:
    'RentalPortal.ApplicantDecisionSelectConfirmTitleKey',
}

export const APPLICANT_DECISION_CONFIRM_TEXT_KEY = {
  [APPLICANT_DECISION_ACTION.approve]:
    'RentalPortal.ApplicantDecisionApproveConfirmTextKey',
  [APPLICANT_DECISION_ACTION.rejectSelection]:
    'RentalPortal.ApplicantDecisionRejectConfirmTextKey',
  [APPLICANT_DECISION_ACTION.select]:
    'RentalPortal.ApplicantDecisionSelectConfirmTextKey',
}

export const APPLICANT_DECISION_NOTE_PLACEHOLDER_KEY = {
  [APPLICANT_DECISION_ACTION.approve]:
    'RentalPortal.ApplicantDecisionReviewerNotePlaceholderKey',
  [APPLICANT_DECISION_ACTION.rejectSelection]:
    'RentalPortal.ApplicantDecisionRejectReasonPlaceholderKey',
  [APPLICANT_DECISION_ACTION.select]:
    'RentalPortal.ApplicantDecisionSelectionNotePlaceholderKey',
}

export const APPLICANT_DECISION_STATUS_TEXT_COLOR = {
  approved: 'var(--color-success)',
  awaiting: 'var(--color-warning)',
  rejected: 'var(--color-error)',
  selected: 'var(--color-success)',
}

export const APPLICANT_DECISION_NOTE_MAX_LENGTH = 1000

export const APPLICANT_DECISION_NOTE_CLAMP_LINES = 3

export const APPLICANT_DECISION_PRIMARY_ACTIONS = [
  APPLICANT_DECISION_ACTION.approve,
  APPLICANT_DECISION_ACTION.select,
]

export const APPLICANT_DECISION_ANCHOR_SCROLL_OPTIONS = {
  behavior: 'smooth',
  block: 'center',
}

export const APPLICANT_DECISION_SAVE_ERROR_NOTIFICATION_ID =
  'applicantDecisionSaveError'

export const APPLICANT_DECISION_RESELECT_NOTIFICATION_ID =
  'applicantDecisionReselect'
